'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'

import { Button } from '@/components/Button'
import { Image } from '@/components/Image'
import Logo from '@/public/logo.svg'
import LogoAtlas from '@/public/logo_atlas.svg'

type T = {}

export const Footer = ({}: T) => {
  const url = usePathname()
  const isContact = url === '/contact'

  return (
    <>
      {!isContact && (
        <section className="relative px-lg">
          <Image src="/contact.jpg" alt="" fill className="brightness-[0.65]" />
          <div className="relative py-12 text-center text-white md:py-40">
            <p className="mb-fz-1 break-keep text-sm font-medium leading-loose md:text-2xl">
              法人・個人問わず、
              <wbr className="block md:inline" />
              各々のステージに寄り添ったサポートを
              <wbr className="md:hidden" />
              提供いたします。
              <br />
              まずはお気軽にご相談ください。
            </p>
            <Button
              text="お問合せ"
              href="/contact"
              className="text-sm md:text-base"
            />
          </div>
        </section>
      )}
      <footer className="pb-4 pt-10 bg-primary-5 md:pb-10 md:pt-15">
        <div className="px-lg">
          <div className="grid grid-cols-2 gap-x-lg gap-y-5 text-xs md:text-sm lg:grid-cols-4">
            <div className="col-span-2 mb-1 md:mb-4 lg:col-span-1 lg:mb-0">
              <Link href="/">
                <Logo className="w-48 xl:w-60" />
              </Link>
            </div>
            <div>
              <p className="pb-2 font-semibold md:pb-3">名古屋事務所</p>
              <p className="leading-normal">
                〒460-0012
                <br />
                愛知県名古屋市中区千代田二丁目13番9
              </p>
            </div>
            <div>
              <p className="pb-2 font-semibold md:pb-3">東京事務所</p>
              <p className="leading-normal">
                〒103-0005
                <br />
                東京都中央区日本橋久松町6番9号
              </p>
            </div>
            <div className="col-span-2 md:col-span-1">
              <p className="pb-3 font-semibold md:pb-4">提携企業</p>
              <a
                href="https://k-cpafirm.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LogoAtlas className="w-36 text-primary transition-opacity hover:opacity-50 md:w-40" />
              </a>
            </div>
          </div>
          <div className="mt-5 justify-between lg:mt-20 lg:flex">
            <nav className="">
              <ul className="grid grid-cols-[auto_auto_auto] gap-x-lg gap-y-3 text-xs lg:flex lg:gap-x-4 lg:text-[13px]">
                {[
                  { text: '堀口会計について', href: '/about' },
                  { text: '確定申告の税務顧問', href: '/service/tax-return' },
                  { text: '企業の税務顧問', href: '/service/tax-advisor' },
                  { text: 'お問合せ', href: '/contact' },
                  { text: '個人情報保護方針', href: '/policy' },
                ].map((a) => (
                  <li key={a.text}>
                    <Link
                      href={a.href}
                      className="underline-offset-2 hover:underline"
                    >
                      {a.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
            <p className="mt-6 text-xxs font-light lg:mt-0 lg:text-xs">
              © 2025, 税理士法人 堀口会計.
            </p>
          </div>
        </div>
      </footer>
    </>
  )
}
